import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (res.data?.token) localStorage.setItem("aw_token", res.data.token);
        setUser(res.data.user);
        const internal = res.data.user?.roles?.some((r) =>
          ["admin", "intern_delivery", "intern_architekt", "intern_audit"].includes(r)
        );
        nav(internal ? "/dashboard" : "/portal", { replace: true });
      } catch (e) {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="font-mono text-xs text-neutral-500" data-testid="auth-callback-loading">
        SITZUNG WIRD HERGESTELLT …
      </div>
    </div>
  );
}
